export default __webpack_public_path__ + "static/media/shenkar.9dbfeacd.PNG";